import API from '@/api/base'
import { getTrackingKey } from '@/utils/api'

// endpoints from the new auth service
class AuthV2API extends API {
  sendOtp = ({ phoneNumber, checkoutId }) => {
    return this.fetcher({
      method: 'POST',
      trackingKey: getTrackingKey(this.uri, 'send-otp'),
      path: this.uri + '/send-otp',
      data: {
        phone_number: phoneNumber,
        checkout_id: checkoutId,
      },
    })
  }

  confirmOtp = ({ code, customerId, checkoutId, fingerprint }) => {
    const data = {
      otp: code,
      customer_id: customerId,
      checkout_id: checkoutId,
    }

    if (fingerprint) {
      data.fingerprint = fingerprint
    }

    return this.fetcher({
      method: 'POST',
      trackingKey: getTrackingKey(this.uri, 'confirm-otp'),
      path: this.uri + '/confirm-otp',
      data,
    })
  }

  resendOtp = ({ checkoutId, customerId }) => {
    const data = {
      customer_id: customerId,
      checkout_id: checkoutId,
    }

    return this.fetcher({
      method: 'POST',
      trackingKey: getTrackingKey(this.uri, 'resend-otp'),
      path: this.uri + '/resend-otp',
      data,
    })
  }
}

export default new AuthV2API('/auth/v1/customers')
